import i18n, { ResourceKey } from "i18next";

import { initReactI18next } from "react-i18next";

import commonUSEngKeys from "./common.en-US.json";
export function initWithOnlyUseEnglish(usEng: ResourceKey) {
  if (typeof usEng !== "object") {
    throw new Error("It should be a valid dictionary");
  }
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      // the translations
      // (tip move them in a JSON file and import them,
      // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
      resources: {
        en: {
          translation: { ...commonUSEngKeys, ...usEng },
        },
      },
      lng: "en", // if you're using a language detector, do not define the lng option
      fallbackLng: "en",

      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    });
}
